<template>
  <div class="voice-player-container">
    <!-- 音频核心播放容器（隐藏原生控件，仅保留逻辑） -->
    <audio
      ref="audioRef"
      :src="voiceUrl"
      @play="handlePlay"
      @pause="handlePause"
      @ended="handleEnded"
      style="display: none;"
    ></audio>

    <!-- 音频提醒弹窗 -->
    <el-dialog :visible.sync="vocieDialogVisible" :show-close="false" :lock-scroll="false">
      <div class="vociePop">
        <div class="close cursor" @click="vocieDialogVisible = false">
            <img src="../src/assets/icon/close.png" alt="">
        </div>
        <div class="kefu">
            <img src="../src/assets/icon/warring.png" alt="">
        </div>
        <p class="kefuDesc">音频播放中，暂不可选择</p>
      </div> 
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VoicePlayer',
  props: {
    // 父组件传递的播放倍速
    // playbackRate: {
    //   type: Number,
    //   default: 1.0,
    //   // 校验倍速有效值
    //   validator: (val) => [0.5, 1.0].includes(val)
    // }
  },
  data() {
    return {
      voiceUrl:'',
      playbackRate:1.0, // 倍速
      // 当前播放状态
      isPlaying: false,
      // 音频实例
      audioInstance: null,
      vocieDialogVisible:false,
    }
  },
  watch: {
    // 监听倍速变化，实时更新播放倍速
    playbackRate(newVal) {
      if (this.audioInstance) {
        this.audioInstance.playbackRate = newVal
        console.log(this.audioInstance.playbackRate)
      }
    },
    // 监听语音链接变化，重置播放状态
    voiceUrl(newVal) {
      if (newVal && this.audioInstance) {
        this.audioInstance.pause()
        this.isPlaying = false
      }
    }
  },
  mounted() {
    // 初始化音频实例
    this.audioInstance = this.$refs.audioRef
    // 初始化倍速
    if (this.audioInstance) {
      this.audioInstance.playbackRate = this.playbackRate
    }
  },
  beforeDestroy() {
    // 组件销毁时清理资源，避免内存泄漏
    if (this.audioInstance) {
      this.audioInstance.pause()
      this.isPlaying = false
      this.audioInstance = null
    }
  },
  methods: {
    // 播放方法（供父组件调用）
    playVoice() {
      if(this.isPlaying){
        this.vocieDialogVisible = true;
        return
      }
      console.log(this.isPlaying,'播放')
      console.log(this.audioInstance,this.voiceUrl)
      if (!this.audioInstance || !this.voiceUrl) {
        alert('语音链接为空，无法播放！')
        return
      }
      // 尝试播放音频
      this.audioInstance.play()
        .catch(err => {
          console.error('语音播放失败：', err)
          alert('语音播放失败，请检查链接或浏览器权限！')
        })
    },
    // 暂停方法（供父组件调用）
    pauseVoice() {
      if (this.audioInstance && this.isPlaying) {
        this.audioInstance.pause()
      }
    },
    // 监听原生播放事件
    handlePlay() {
      this.isPlaying = true
      this.audioInstance.playbackRate = this.playbackRate;
      this.$emit('voice-playing') // 可选：通知父组件开始播放
    },
    // 监听原生暂停事件
    handlePause() {
      this.isPlaying = false
      this.$emit('voice-paused') // 可选：通知父组件已暂停
    },
    // 监听播放结束事件
    handleEnded() {
      this.isPlaying = false
      this.$emit('voice-ended') // 可选：通知父组件播放结束
    },

    // 可选：获取当前播放状态（供父组件查询）
    getPlayState() {
      return {
        isPlaying: this.isPlaying,
        currentTime: this.audioInstance?.currentTime || 0,
        duration: this.audioInstance?.duration || 0
      }
    }
  }
}
</script>

<style scoped lang="less">
.voice-player-container {
  margin: 16px 0;
}

.playing-tip {
  padding: 8px 16px;
  background: #f0f9ff;
  border: 1px solid #c6e2ff;
  border-radius: 4px;
  color: #1989fa;
  font-size: 14px;
  display: inline-block;
}
.vociePop{
    width: 600px;
    height: 240px;
    padding-top: 45px;
    box-sizing: border-box;
    border-radius: 30px;
    background: linear-gradient(180deg, #D8FDE0 0%, #FFFFFF 53%);
    position: relative;
    .close{
        width: 16px;
        height: 16px;
        position: absolute;
        top: 19px;
        right: 16px;
        img{
            width: 16px;
              height: 16px;
        }
    }
    .kefu{
        width: 64px;
        height: 64px;
        margin: 0 auto;
        img{
            width: 64px;
            height: 64px;
        }
    }
    .kefuDesc{
        margin-top: 30px;
        color: #3D3D3D;
        font-size: 22px;
        text-align: center;
    }
    .goLogin{
        margin: 23px auto 0;
        color: #FFFFFF;
        font-size: 15px;
        width: 200px;
        height: 50px;
        border-radius: 100px;
        background: #5CC971;
        display: flex;
        align-items: center;
        justify-content: center;
    }
  }
</style>